import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";

export const Services = () => {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="bg-[#FAF8F2] py-24 sm:py-32 scroll-mt-24"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-[#9A8420]" />
            <span className="eyebrow text-[#9A8420]">Unsere Leistungen</span>
          </div>
          <h2 className="mt-6 font-bold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#16273F]">
            Automatisierungen, die Ihnen sofort Arbeit abnehmen
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Keine komplizierten Systeme. Wir richten genau das ein, was in Ihrem
            Betrieb den größten Unterschied macht — verständlich erklärt. Und wo
            es keine Standardlösung gibt, entwickeln wir gemeinsam mit Ihnen eine.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              className="group relative flex flex-col bg-white border border-slate-200/80 p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(22,39,63,0.35)]"
              style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 24px 100%, 0 calc(100% - 24px))" }}
            >
              <div className="flex items-start justify-between">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#16273F] text-[#C9A94A]">
                  <s.icon className="w-7 h-7" strokeWidth={1.5} />
                </div>
                <ArrowUpRight className="w-6 h-6 text-slate-300 transition-all duration-300 group-hover:text-[#9A8420] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
              <span className="mt-7 eyebrow text-[#9A8420]">{s.kicker}</span>
              <h3 className="mt-3 font-bold text-2xl text-[#16273F] leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.text}</p>
              <ul className="mt-6 pt-6 border-t border-slate-100 space-y-2.5">
                {s.points.map((pt) => (
                  <li key={pt} className="flex items-center gap-3 text-sm text-slate-700">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#9A8420]" />
                    {pt}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
